enum PartialShipBehaviorEnum {
    /**
     * Partial shipment splits the unshipped remainder into a backorder (current behavior).
     */
    SPLIT_TO_BACKORDER = "split_to_backorder",
    /**
     * Fulfillment is committed via explicit "Release for Shipment" actions: outstanding
     * qty reduces in place on the original order (no backorder child) and shipment
     * records are informational only.
     */
    RELEASE_FOR_SHIPMENT = "release_for_shipment",
}

export default PartialShipBehaviorEnum;
